import apiMiddleware from 'middleware/api'
import { captureConfirm, releaseConfirm } from './confirm'
import timestampMiddleware from 'middleware/timestamp'
import idMiddleware from 'middleware/id'
import notifyMiddleware from 'middleware/notify'
import retryMiddleware from 'middleware/retry'
import ensureFocusMiddleware from 'middleware/ensureFocus'
import previousNeighborhoodMiddleware from 'middleware/previousNeighborhood'
import updateNeighborhoodMiddleware from 'middleware/updateNeighborhood'
import selectionMiddleware from './selection'
import socketMiddleware from './socket'
import contentGenerationMiddleware from './contentGeneration'
import graphQueryMiddleware from './graphQuery'
import shapesMiddleware from './shapes'


export default () => [
  socketMiddleware,
  timestampMiddleware,
  idMiddleware,
  captureConfirm,
  releaseConfirm,
  notifyMiddleware,
  selectionMiddleware,
  ...apiMiddleware(),
  contentGenerationMiddleware,
  graphQueryMiddleware,
  shapesMiddleware,
  retryMiddleware,
  ensureFocusMiddleware,
  previousNeighborhoodMiddleware,
  updateNeighborhoodMiddleware,
]
